import axios from 'axios'
import { stringify } from 'qs'
import app from 'utils/app'
import store from 'store'
import router from 'router'
import { getCookie } from 'utils/common'
import API from 'api'
import isDefaultHideTitle from 'utils/clientEnv'
import env from '@/utils/clientEnv'


let devBaseUrl

// devBaseUrl = 'http://api.vivo.xyz/mockApi/vivoshop/api'
devBaseUrl = '/wap/fbApi'
// devBaseUrl = '/api'

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/wap/fbApi' : devBaseUrl,
  withCredentials: true,
  timeout: 60000, // 请求超时时间60s
  paramsSerializer: params =>
    stringify(params, {
      indices: false
    }) // 数组序列化
})

service.interceptors.request.use(
  async config => {
    // 为请求统一加上authCode，这里的config.url是指业务代码里面的url，不会包含baseURl
    if (config.url.indexOf('//') === -1 && !/^(\/v\d\/)/.test(config.url) && !config.nov1) {
      config.url = '/v1' + config.url
    }
    const authCode = sessionStorage.getItem('authCode')
    if (authCode) {
      config.params = Object.assign({}, config.params, {
        authCode
      })
    }
    // isDefaultHideTitle 配合H5极开SDK，新版本中请求去掉时间戳
    if ((config.method === 'get' || config.method === 'GET') && !isDefaultHideTitle) {
      config.params = Object.assign({}, config.params, {
        t: Date.now()
      })
    } else if((config.method === 'get' || config.method === 'GET') && config.addNoCache){
      config.headers['Cache-Control'] = 'no-cache'
    }

    if (config.useJsonType) {
      config.headers['Content-Type'] = 'application/json; charset=UTF-8'
    }
    const shop_token = getCookie('shop_token')
    if (shop_token) {
      if (config.url.indexOf('header/getHF') === -1) {
        config.headers['shop_token'] = shop_token
      }
    } else if (config.url.indexOf('/common/cookie') === -1) {
      await API.initAuthInfo()
    }
    // 获取token，配合服务端解决csrf安全问题
    if (config.setCsrfToken) {
      const token = await service({
        url: '/my/token'
      })
      if (token) {
        config.params = config.params || {}
        config.params.token = token
        if (config.method.toLowerCase() === 'post' && config.data) {
          config.data.token = token
        }
        delete config.setCsrfToken
      } else {
        return false
      }
    }
    if(config.url.indexOf('/shopcart/') > 0){
      const bankchannel = sessionStorage.getItem('bankchannel')
      if(bankchannel){
        config.params = config.params || {}
        config.params.bankchannel = bankchannel
        if (config.method.toLowerCase() === 'post' && config.data) {
          config.data.bankchannel = bankchannel
        }
      }
      if(config.checkFromWxMini){
        const isWechat = await env.checkWeChat()
        isWechat && (config.headers['source'] = 'wx_mini')
      }
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      let { code, data, msg, retCode, retMsg } = response.data
      code = code * 1
      if (retCode !== undefined) {
        code = retCode * 1
      }
      if (retMsg !== undefined) {
        msg = retMsg
      }
      if (code === 0) {
        // 成功，直接传入{code: '', data: '', msg: ''}中的data字段，否则将整个响应信息传下去
        return data
      } else if (
        (Object.is(code, NaN) || code === undefined) &&
        !(response.data === undefined || response.data === null || response.data === '')
      ) {
        return data || response.data // 不添加pdf base64文件流undefined
      } else if (code === 600 || code === 601) {
        // 600 未登陆，601登录失效
        if (response && response.config && response.config.unLogin) {
          return Promise.reject(response && response.data)
        } else {
          if (window.location.href.search('laser/confirm') > -1) {
            return Promise.reject(response && response.data)
          }
          // 强校验登录接口存在其他异常校验，避免同时触发登录和异常逻辑
          if (response && response.config && response.config.unLoginNoReject) {
            return response.data
          }
          app.login()
          return Promise.reject(Object.assign({}, response.data, { msg: '' }))
        }
      } else if (code === 500) {
        // 若在请求中配置shwoErrorPage: true, 则在code：500时转到错误页
        if (response.config.showErrorPage) {
          store.dispatch('setPageErrorState', { status: true, title: msg })
          return new Promise(() => { })
        }
        return Promise.reject(response.data)
      } else if (code === 602) {
        // 602 forbidden
        router.push({
          name: 'forbidden'
        })
        return new Promise(() => { })
      } else {
        let errObj = {
          data: '',
          msg: '请求异常'
        }

        // 按照{code: '', data: '', msg: ''}的形式返回的
        if (typeof response.data === 'object') {
          errObj = Object.assign({}, errObj, response.data)
        }

        // 请求到达服务器，但未按照约定格式返回
        // return Promise.reject(errObj)
        return Promise.reject(errObj)
      }
    }
  },
  error => {
    const errorResponse = error.response
    // 在控制台打印日志
    if (errorResponse && errorResponse.status) {
      console.log(`请求错误，错误状态：${errorResponse.status}`)
      if (errorResponse.config.isReject) {
        let errObj = {
          data: null,
          msg: `请求异常: ${errorResponse.status}`
        }
        return Promise.reject(errObj)
      }
    }
    // 主请求若配置了错误页，则提示错误后跳转到错误页
    if (errorResponse && errorResponse.config && errorResponse.config.showErrorPage) {
      store.dispatch('setPageErrorState', { status: true })
      return new Promise(() => { })
    }
    return new Promise(() => { })
  }
)

export default service
